<script lang="ts" setup>
defineProps<{
  slideable?: true
}>()
</script>

<template>
  <div
    class="container min-w-sm max-w-md px-6 lg:mx-auto lg:max-w-screen-lg lg:px-16 xl:max-w-screen-lg"
    :class="{ '<lg:overflow-x-scroll': slideable }"
  >
    <div v-if="slideable" class="<lg:min-w-full <lg:float-left">
      <slot/>
    </div>
    <template v-else>
      <slot/>
    </template>
  </div>
</template>
